<template lang="pug">
  base-edge(v-bind="$attrs"
        :path="path[0]"
        :marker-end="markerEnd"
        :label="shortLabel"
        :label-x="path[1]"
        :label-y="path[2]"
        :label-style="{ fill: '#555', textAnchor: 'start' }"
        :label-show-bg="true"
        :label-bg-style="{ fill: '#FFF' }"
        :label-bg-border-radius="2"
        style="pointer-events: none")
  edge-label-renderer
    div.edge-tooltip.nodrag.nopan.nowheel(v-if="selected"
            :style="{ pointerEvents: 'all', position: 'absolute', transform: `translate(-50%, -100%) translate(${path[1]}px, ${path[2] - 15}px)`}"
            @mousedown.stop
            @click.stop
            @wheel.stop)
      div.edge-tooltip__content {{ label }}
</template>

<script>
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from '@vue-flow/core';
import { LABEL_CHARS_LIMITATION } from '../DiagramHelper';

export default {
  name: 'DiagramCustomEdge',
  inheritAttrs: false,
  components: {
    BaseEdge,
    EdgeLabelRenderer,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    sourceX: Number,
    sourceY: Number,
    targetX: Number,
    targetY: Number,
    sourcePosition: String,
    targetPosition: String,
    label: String,
    markerEnd: String,
    style: Object,
    selected: {
      type: Boolean,
      default: false,
    },
    curvature: {
      type: Number,
      default: 0.3,
    },
  },
  computed: {
    path() {
      return getBezierPath(this);
    },
    shortLabel() {
      return this.label?.length > LABEL_CHARS_LIMITATION ? `${this.label.slice(0, LABEL_CHARS_LIMITATION)}…` : this.label;
    },
  },
};
</script>

<style scoped>
.edge-tooltip {
  z-index: 10;
}

.edge-tooltip__content {
  max-width: 200px;
  background: #FFF;
  color: #555;
  padding: 4px 5px;
  font-size: 7px;
  line-height: 1.35;
  border-radius: 6px;
  white-space: normal;
  word-break: break-word;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.25);
  text-align: left;
  border: 1px solid #EFEFEF;
  position: relative;
}

.edge-tooltip__content::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #fff;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.08));
}

.edge-tooltip__content::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translateX(-50%) translateY(1px);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid rgba(0,0,0,0.06);
}
</style>